var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil4887028(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.38 14.6199L6.84001 14.2599L5.74 13.1599L5.38 14.6199Z",
    fill: "#4298C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24341 12.0247L11.2793 6.98876L13.0057 8.71519L7.96984 13.7511L6.24341 12.0247Z",
    fill: "#4298C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5134 5.26659C13.3735 5.12667 13.1467 5.12663 13.0068 5.26646L13.0067 5.26659L12.1067 6.16659L13.8334 7.89326L14.7334 6.99326C14.8733 6.85346 14.8734 6.62676 14.7336 6.48684C14.7335 6.48676 14.7334 6.48667 14.7334 6.48659L13.5134 5.26659Z",
    fill: "#4298C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47717 0 0 4.47717 0 10C0 15.5228 4.47717 20 10 20C15.5228 20 20 15.5228 20 10C19.998 4.478 15.522 0.002 10 0ZM15.5533 7.81333L8.38667 14.98C8.31021 15.0537 8.21608 15.1065 8.11333 15.1333L4.72 15.98C4.409 16.0556 4.09563 15.8648 4.02 15.5538C3.99813 15.4639 3.99813 15.37 4.02 15.28L4.86667 11.8867C4.89383 11.7855 4.944 11.6919 5.01333 11.6133L12.1867 4.44667C12.7787 3.85388 13.7391 3.85325 14.3319 4.44521C14.3324 4.44571 14.3328 4.44617 14.3333 4.44667L15.5533 5.66667C16.1461 6.25554 16.1493 7.2135 15.5604 7.80629C15.558 7.80863 15.5557 7.811 15.5533 7.81333Z",
    fill: "#4298C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil4887028);
export default __webpack_public_path__ + "static/media/pencil_4887028.308ad1cbeac8473b38be5b042447986f.svg";
export { ForwardRef as ReactComponent };